import React, { PropTypes } from 'react'
import { Translate } from 'unity-core'

const propTypes = {
  strings: PropTypes.object.isRequired
}
const defaultProps = {}

const Unauthroized = ({ strings }) => {

  return (
    <div className="container-fluid">
      <div className="container-fluid text-center"><h2>{strings.WelcomeMessage}</h2></div>
      <div className="container-fluid">
        <div className="notice notice-warning">
          <div className="notice-content" dangerouslySetInnerHTML={{ __html: strings.NoBLTRolesFound }} />
        </div>
      </div>
    </div>
  )
}

Unauthroized.propTypes = propTypes
Unauthroized.defaultProps = defaultProps

export default Translate('ContentPermission')(Unauthroized)
